import React from 'react';
import { message } from 'antd';
import Button from '../../../../../../components/Button';
import TableColumnImg from '../../../../../../components/table/TableColumnImg';
import OpenProductDetail from '../../../../../../components/link/OpenProductDetail';
import TableFilterInput from '../../../../../../components/table/TableFilterInput';
import OpenPreviewProductDetail from '../../../../../../containers/app/common/OpenPreviewProductDetail';
import Select from '../../../../../../components/input/Select/Select';
import OpenBrandDetail from '../../../../../../components/link/OpenBrandDetail';
import Anchor from '../../../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { PRODUCT_EDIT_URL_PATH } from '../../../../../../constants/service/common/urlConstants';
import {
  PRODUCT_PROPERTY_REQUEST_STATUS_SELECT_LIST,
  PRODUCT_STATUS_TEXT,
} from '../../../../../../constants/service/app/productConstants';
import { addAllItemToSelectList, reDirectPage, setColumnWidth, setDetailPageUrl } from '../../../../../../lib/common';
import { setDateFormat } from '../../../../../../lib/moment';

const columns = (data) => {
  const {
    list,
    filterOption,
    onFilter,
    getProductSubCategoryList,
    mainProductCategorySelectList,
    subProductCategorySelectList,
  } = data;

  return [
    {
      Header: '검수하기',
      fixed: 'left',
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="검수하기"
          onClick={() => reDirectPage({ path: setDetailPageUrl(PRODUCT_EDIT_URL_PATH, row.original.productId) })}
        />
      ),
    },
    {
      accessor: 'url',
      Header: '메인 이미지',
      fixed: 'left',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: true,
      fixed: 'left',
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      fixed: 'left',
      filterable: true,
      width: setColumnWidth(list, 'mainCategory') + 40,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(mainProductCategorySelectList)}
          onChange={(mainCategory) =>
            onFilter({
              mainCategory,
              subCategory: null,
            })
          }
          defaultValue={filterOption.mainCategory}
          value={filterOption.mainCategory}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'isSubCategoryExists',
      Header: '2차 카테고리',
      fixed: 'left',
      filterable: true,
      width: setColumnWidth(list, 'isSubCategoryExists') + 40,
      Cell: (row) =>
        row.value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: row.original.productId,
              })
            }
          />
        ) : (
          '-'
        ),
      Filter: () => (
        <Select
          onDropdownVisibleChange={() =>
            !filterOption.mainCategory && message.error('1차 카테고리를 먼저 선택해주세요.')
          }
          dropdownStyle={!filterOption.mainCategory ? { display: 'none' } : undefined}
          list={addAllItemToSelectList(subProductCategorySelectList[filterOption.mainCategory])}
          onChange={(subCategory) => onFilter({ subCategory })}
          defaultValue={filterOption.subCategory}
          value={filterOption.subCategory}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'brandName',
      Header: '브랜드',
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'brandName'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.brandName} onFilter={(brandName) => onFilter({ brandName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      fixed: 'left',
      width: 70,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => PRODUCT_STATUS_TEXT[row.value] || '-',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(PRODUCT_PROPERTY_REQUEST_STATUS_SELECT_LIST)}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'productNumber',
      Header: '제품번호',
    },
    {
      accessor: 'confirmProductPropertyCreateDate',
      Header: '최근 검수 요청 일시',
      sortable: true,
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
